import type { WarrantyConfig } from '#types/config/components/form/warranty'

export default {
  hasMerchandiseCredit: false,
  styleNumberHintImage: 'https://assets.timberland.com/image/upload/v1757592138/style-number'
} satisfies WarrantyConfig
